import { clsx } from 'clsx';
import { PropsWithChildren } from 'react';
import { Button, Tooltip, TooltipTrigger } from 'react-aria-components';
import Icon from '~/components/data-display/Icon';
import Card from '~/components/layout/Card';
import { HStack, VStack } from '~/components/layout/Stack';
import Text, { TextProps } from '~/components/typographies/Text';
import InfoIcon from '~/icons/icon-info-round-stroke.svg?react';
import styles from './InfoTooltip.module.scss';

interface Props {
  className?: string;
  title: string;
  titleProps?: TextProps;
}

const InfoTooltip: React.FC<PropsWithChildren<Props>> = ({
  children,
  className,
  title,
  titleProps = {
    // default style
    variant: 'body2',
    weight: 'semibold',
  },
}) => {
  return (
    <TooltipTrigger delay={0} closeDelay={0}>
      <Button className={styles.tooltipIcon}>
        <Icon component={InfoIcon} size="sm" />
      </Button>
      <Tooltip className={clsx(styles.tooltip, className)}>
        <Card padding={2} shadow="medium">
          <VStack gap={2}>
            <HStack gap={1} align="center">
              <Icon component={InfoIcon} size="sm" />
              <Text {...titleProps}>{title}</Text>
            </HStack>
            {children}
          </VStack>
        </Card>
      </Tooltip>
    </TooltipTrigger>
  );
};

export default InfoTooltip;
